import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const network_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M15.501,12 C15.501,13.954 13.954,15.5 12,15.5 C10.046,15.5 8.5,13.954 8.5,12 C8.5,10.046
      10.046,8.504 12,8.504 C13.954,8.504 15.501,10.046 15.501,12 Z M20.5098,7 C20.5098,7.844 19.8438,
      8.5 18.9998,8.5 C18.1558,8.5 17.4998,7.844 17.4998,7 C17.4998,6.156 18.1558,5.495 18.9998,5.495
      C19.8438,5.495 20.5098,6.156 20.5098,7 Z M21.5,15.5 C21.5,16.636 20.636,17.5 19.5,17.5 C18.364,
      17.5 17.5,16.636 17.5,15.5 C17.5,14.364 18.364,13.5 19.5,13.5 C20.636,13.5 21.5,14.364 21.5,15.5
      Z M7.5059,18.498 C7.5059,19.628 6.6299,20.5 5.4999,20.5 C4.3709,20.5 3.4999,19.628 3.4999,18.498
      C3.4999,17.369 4.3709,16.5 5.4999,16.5 C6.6299,16.5 7.5059,17.369 7.5059,18.498 Z M7.5,4 C7.5,4.85
      6.85,5.5 6,5.5 C5.15,5.5 4.5,4.85 4.5,4 C4.5,3.15 5.15,2.5 6,2.5 C6.85,2.5 7.5,3.15 7.5,4 Z
      M6.9736,5.1514 L9.9086,9.1834 M17.7646,7.8638 L14.8226,9.9128 M17.6816,14.6416 L15.1796,13.4836
      M6.9131,17.0625 L9.5381,14.5025"
      />
    </svg>
  );
};
